/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirements, FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirements';
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultPersonalInfoRequirementsFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultPersonalInfoRequirementsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultPersonalInfoRequirementsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirements(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultPersonalInfoRequirementsToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultPersonalInfoRequirementsToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultPersonalInfoRequirementsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirements(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultPersonalInfoRequirements.js.map